import type { Variant } from '../types';

export interface AvatarProps {
  src?: string;
  alt?: string;
  /** Pixel size; maps to Limitless w-/h- utility classes (24/32/40/48). */
  size?: 24 | 32 | 40 | 48;
  /** Status dot color; omit for no indicator. */
  status?: Variant | 'grey';
  /** Fallback initials shown when no src is given. */
  initials?: string;
  className?: string;
}

/** Round avatar with optional status indicator dot, matching Limitless markup. */
export function Avatar({ src, alt = '', size = 32, status, initials, className = '' }: AvatarProps) {
  const dim = `w-${size}px h-${size}px`;
  const img = src ? (
    <img src={src} className={`${dim} rounded-pill`} alt={alt} referrerPolicy="no-referrer" />
  ) : (
    <span
      className={`${dim} rounded-pill bg-primary bg-opacity-10 text-primary d-inline-flex align-items-center justify-content-center fw-semibold`}
    >
      {(initials ?? '?').slice(0, 2).toUpperCase()}
    </span>
  );

  if (!status) return <span className={className}>{img}</span>;

  return (
    <span className={`status-indicator-container ${className}`.trim()}>
      {img}
      <span className={`status-indicator bg-${status}`} />
    </span>
  );
}
